import React, { useEffect, useState, useRef } from "react";
import "../styles/Donations.css";
import ClientPortrait from "../images/aslamsb.png"; // Client's portrait image
import DecorativeImage from "../images/donation.png"; // Decorative image

const Donations = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer for visibility detection
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="donations-section" ref={sectionRef}>
      {/* Decorative Image */}
      {isVisible && (
        <img
          src={DecorativeImage}
          alt="Decorative"
          className="donation-decoration"
        />
      )}
      
      <div className="donations-container">
        {/* Left Column: Donation Info */}
        <div className="donations-content">
          <h2 className="donations-heading">Support Our Mission</h2>
          <p className="donations-description">
            Your support enables us to provide quality Islamic education, develop innovative learning solutions,
            and build infrastructure that benefits the community. If you'd like to contribute or discuss donations, 
            please reach out directly.
          </p>
          <div className="donor-info">
            <h3 className="donor-name">Mr. Aslam Sharif</h3>
            <p className="donor-role">Founder & Head of Qibla Schools</p>
            <p className="donor-contact">
              <strong>Email:</strong> <a href="mailto:m2aslam@gmail.com">m2aslam@gmail.com</a>
            </p>
            <p className="donor-contact">
              <strong>Phone:</strong> +92 300 8427 613
            </p>
          </div>
          {/* Email functionality on button click */}
          <a href="mailto:m2aslam@gmail.com?subject=Donation Inquiry&body=Assalamualaikum, I would like to contribute to Qibla Schools. Please provide me with further details."
            className="donate-button">
            Contact for Donations
          </a>
        </div>

        {/* Right Column: Client Portrait */}
        <div className={`donor-image-container ${isVisible ? "fade-in" : ""}`}>
          <img src={ClientPortrait} alt="Aslam Khan" className="donor-image" />
        </div>
      </div>
    </section>
  );
};

export default Donations;
